import { withFormik } from 'formik';

import { IContent, PageProps } from 'types';
import { getErrorMessage } from 'utilities';

import { PrivacyPolicyForm } from '..';

export const PrivacyPolicyFormWrapper = withFormik<IContent & PageProps<IContent>, any>({
  // Transform outer props into form values
  mapPropsToValues: ({ content }): Partial<IContent> => {
    return {
      content
    };
  },

  handleSubmit: async (props, formik) => {
    const { name, endpoint, values, ...rest } = props;
    const {
      props: { onSubmit, onSuccessToast, onFailureToast }
    } = formik;

    if (onSubmit) {
      try {
        await onSubmit(rest);
        onSuccessToast && onSuccessToast();
      } catch (error) {
        const err = error as any;
        const msg = getErrorMessage(error) || err.message;
        onFailureToast && onFailureToast(msg);
      }
    }
  }
})(PrivacyPolicyForm);
